import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import sal from 'sal.js'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import Tabs from '../components/tabs.svelte'
import Login from '../components/login.svelte'
import lozad from 'lozad'
import Popup from '../components/jobs-popup.svelte'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		// JavaScript to be fired on all pages
		const mobileMenu = new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})

		$('#toggle_nav').on('click', mobileMenu.show)

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)

		$(window).scroll((e) => {
			let nav = $('.navbar-wrap')
			let scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop
			scrollTop >= nav.height()
				? nav.addClass('fixed-nav')
				: nav.removeClass('fixed-nav')
		})

		let $tabsWrapper = $('.tab-wrapper')
		if ($tabsWrapper.length) {
			$.each($tabsWrapper, function () {
				new Tabs({
					target: this,
					props: this.dataset,
				})
			})
		}

		// restrict "preferred project size subfield to have values of 1-5 only"
		$.each($('#field_10_107 .gfield_list_groups input'), function (idx, el) {
			el.type = 'number'
			el.min = '1'
			el.max = '5'
			el.addEventListener('change', function (e) {
				if (!/^\d+$/.test(e.target.value) || e.target.value > 5) {
					e.target.value = ''
				}
			})
		})
	},
	finalize() {
		// const el = document.querySelector('img');
		// const observer = lozad(el); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid
		// observer.observe();

		// JavaScript to be fired on all pages, after page specific JS is fired
		let $article = $('article.main-content')

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		// article enlarge images
		if ($article.length) {
			$article
				.find(
					'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
				)
				.on('click', function (e) {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
						noLoader: true,
					})
				})
		}
		let $wpBlockImg = $('.wp-block-image:not(.no-bp)')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
					noLoader: true,
				})
			})
		}

		let $blocksGallery = $('.wp-block-gallery .wp-block-image  > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		sal({
			threshold: 0.01,
			rootMargin: '-5px 9px',
		})

		let $subImages = $('#subImages')
		if ($subImages.length) {
			$('.lightbox').on('click', function () {
				if (this.style.backgroundImage == 'url("false")') return
				BigPicture({
					el: this,
					gallery: '#subImages',
					loop: true,
					noLoader: true,
				})
			})
		}

		$('img:not(.wp-post-image, .participants .bg-img)').on('click', function () {
			let url = this.src
			BigPicture({
				el: this,
				imgSrc: url,
				noLoader: true,
			})
		})

		$('img:not(.wp-post-image, .participants .bg-img)').on('click', function () {
			let url = this.src
			BigPicture({
				el: this,
				imgSrc: url,
				noLoader: true,
				//gallery: Array.from(document.querySelectorAll('img')).map(img => img.src)
			})
		})

		let $blockTestimonials = $('#blockTestimonials')
		if ($blockTestimonials.length) {
			tns({
				container: '#blockTestimonials',
				items: 1,
				slideBy: 1,
				autoplay: true,
				nav: true, //dots
				controls: false, //arrows
				touch: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,
				autoHeight: true,
				loop: true,
				// mouseDrag: false,
				speed: 750,
			})
		}

		let $blockSlideShowText = $('#blockSlideShowText')
		if ($blockSlideShowText.length) {
			tns({
				container: '#blockSlideShowText',
				items: 1,
				slideBy: 1,
				autoplay: true,
				nav: false, //dots
				controls: true, //arrows
				touch: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,
				autoHeight: true,
				loop: true,
				// mouseDrag: false,
				speed: 750,
				controlsText: [
					'<span>Prev</span><svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 125"><g transform="translate(0,-952.36218)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 71.35934,1002.3622 -4.25,-4.25004 -29.99998,-30 -8.4687,8.5 25.74993,25.75004 -25.74993,25.75 8.4687,8.5 29.99998,-30 4.25,-4.25 z" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg>',
					'<span>Next</span><svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 125"><g transform="translate(0,-952.36218)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 71.35934,1002.3622 -4.25,-4.25004 -29.99998,-30 -8.4687,8.5 25.74993,25.75004 -25.74993,25.75 8.4687,8.5 29.99998,-30 4.25,-4.25 z" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg>',
				],
			})
		}

		//taxonomy page
		function adjustHeight() {
			$('.other-projects .column').height($('.other-projects .column').width())
			$('.card-image').height($('.card-image').width())
			$('.tns-slider').height($('.tns-item').width())
		}

		function runFunctions() {
			//fitText($('.cta .main > span:first-child')[0])
			adjustHeight()
		}
		//window.onload = () => {
		// runFunctions()
		// window.onresize = () => runFunctions()

		if (window.login_form_object) {
			new Login({
				target: document.body,
				props: {
					loginLinks: $('.client-login > a'),
				},
			})
		}

		let jobsBlock = document.querySelector('.jobs-block')
		if (jobsBlock) {
			new Popup({
				target: document.body,
			})
		}
	},
}
